/**
 * 全局对象.
 *
 * @author  yusangeng@outlook.com
 */
/* istanbul ignore file */
var g;
if (typeof window !== "undefined") {
    g = window;
}
else if (typeof global !== "undefined") {
    g = global;
}
else if (typeof self !== "undefined") {
    g = self;
}
else {
    g = {};
}
export default g;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2xvYmFsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2dsb2JhbC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7OztHQUlHO0FBRUgsMEJBQTBCO0FBRTFCLElBQUksQ0FBTSxDQUFDO0FBRVgsSUFBSSxPQUFPLE1BQU0sS0FBSyxXQUFXLEVBQUU7SUFDakMsQ0FBQyxHQUFHLE1BQU0sQ0FBQztDQUNaO0tBQU0sSUFBSSxPQUFPLE1BQU0sS0FBSyxXQUFXLEVBQUU7SUFDeEMsQ0FBQyxHQUFHLE1BQU0sQ0FBQztDQUNaO0tBQU0sSUFBSSxPQUFPLElBQUksS0FBSyxXQUFXLEVBQUU7SUFDdEMsQ0FBQyxHQUFHLElBQUksQ0FBQztDQUNWO0tBQU07SUFDTCxDQUFDLEdBQUcsRUFBRSxDQUFDO0NBQ1I7QUFFRCxlQUFlLENBQUMsQ0FBQyJ9